import {theme} from './theme'

export const CONTAINER_WIDTH = '1124px'
export const CONTAINER_PADDING = theme.spacing[5]
export const CONTAINER_PADDING_MOBILE = theme.spacing[3]

// WCAG 2.5.8 minimum size of a click target
export const MIN_TARGET_SIZE = 24

export const SECTION_PADDING_DESKTOP = theme.spacing[9.5]
export const SECTION_PADDING_MOBILE = theme.spacing[8]

export const HEADER_HEIGHT_DESKTOP = '88px'
export const HEADER_HEIGHT_MOBILE = '92px'
export const HEADER_CONTENT_HEIGHT_MOBILE = '80px'
export const HEADER_MAX_WIDTH = '1920px'
export const HEADER_PADDING_DESKTOP = theme.spacing[3]
export const HEADER_PADDING_MOBILE = theme.spacing[2.5]
export const HEADER_AUTH_SLOT_HEIGHT = '42px' // LoginButton: 40px height + 1px outline each side
// Space above an anchor scrolled to on mobile. The header is at the bottom there, but Chrome on iOS
// lays its toolbar over the top of the page; Safari needs none and gets a small gap.
export const MOBILE_ANCHOR_OFFSET = '92px'

export const HERO_PADDING_DESKTOP = theme.spacing[7]
export const HERO_PADDING_MOBILE = theme.spacing[6]

export const STATIC_CONTENT_WIDTH = '700px'
export const CONTENT_LAYOUT_WIDTH = '750px'
export const CONTENT_LAYOUT_SIDEBAR_WIDTH = '310px'
export const BLOG_CONTENT_WIDTH = '800px'
export const BLOG_SIDEBAR_WIDTH = '285px'
export const BLOG_HERO_IMAGE_WIDTH_DESKTOP = '340px'
export const BLOG_HERO_IMAGE_HEIGHT_DESKTOP = '455px'
export const BLOG_HERO_IMAGE_WIDTH_MOBILE = '190px'
export const BLOG_HERO_IMAGE_HEIGHT_MOBILE = '250px'
export const BLOG_THUMBNAIL_WIDTH = '230px'
export const BLOG_THUMBNAIL_HEIGHT = '160px'

export const TIMELINE_WIDTH = '3px'
export const TIMELINE_CIRCLE_SIZE_LARGE = '28px'
export const TIMELINE_CIRCLE_SIZE_SMALL = '16px'

export const FORM_INPUT_HEIGHT = '40px'
export const FORM_TEXTAREA_MAX_HEIGHT = '400px'
export const FORM_CONTAINER_WIDTH = '960px'
export const FORM_CONTAINER_PADDING = theme.spacing[5]
export const FORM_CONTAINER_PADDING_MOBILE = theme.spacing[3]
export const FORM_CONTENT_WIDTH = '512px'
export const FORM_SIDEBAR_WIDTH = '320px'
export const FORM_CONTENT_WIDTH_WITHOUT_SIDEBAR = '736px'
export const FORM_MODAL_WIDTH = '640px'
export const FORM_DROPZONE_HEIGHT = '80px'
export const FORM_PERCENTAGE_CIRCLE_SIZE = '60px'
export const FORM_SUMMARY_HEIGHT_MOBILE = '57px'
export const APPLICATION_FORM_DRAWER_WIDTH = '480px'
export const APPLICATION_FORM_MODAL_WIDTH = '496px'
export const APPLICATION_FORM_INPUT_HEIGHT = '32px'
export const APPLICATION_FORM_SUBMIT_MODAL_WIDTH = '312px'
export const APPLICATION_FORM_UNSAVED_BANNER_HEIGHT = '36px'

export const DROPZONE_HEIGHT_DESKTOP = '200px'
export const DROPZONE_HEIGHT_MOBILE = '120px'

export const SERVICES_MODAL_WIDTH = '960px'
export const SERVICES_MODAL_SIDEBAR_WIDTH = '320px'
export const SERVICES_MODAL_HEADER_HEIGHT = '70px'
export const SERVICES_MODAL_FOOTER_HEIGHT_DESKTOP = '110px'
export const SERVICES_MODAL_FOOTER_HEIGHT_MOBILE = '78px'

export const SUCCESS_TIMELINE_STEP_WIDTH = '150px'
export const SUCCESS_CONTENT_WIDTH = '800px'
export const SUCCESS_REASSURANCE_BANNER_WIDTH = '570px'

export const TABLE_FORM_ROW_HEIGHT = '32px'
export const AVATAR_SIZE_SMALL = '24px'
export const AVATAR_SIZE_MEDIUM = '32px'
export const AVATAR_SIZE_LARGE = '40px'
export const USER_FORM_WIDTH = '560px'
export const USER_NOTIFICATIONS_DROPDOWN_WIDTH = '400px'
export const USER_CONTAINER_WIDTH = '950px'
export const USER_MODAL_CONTENT_WIDTH = '490px'
export const USER_TRADEMARK_CARD_WIDTH = '240px'
export const USER_TRADEMARK_CARD_HEIGHT = '191px'
export const USER_NO_RESULTS_MAX_WIDTH = '405px'
export const USER_SOLUTION_CENTER_MODAL_WIDTH = '656px'
export const USER_SIDEBAR_COLLAPSED_WIDTH = '88px'
export const USER_EMPTY_SCREEN_MAX_WIDTH = '720px'
export const USER_FILTER_MENU_WIDTH = '185px'
export const USER_BRAND_GRID_SIZE = '115px'
export const USER_MOBILE_MENU_HEIGHT = '80px'
export const USER_TAB_SIDEBAR_WIDTH = '395px'
export const USER_PRODUCT_ONBOARDING_TOOLTIP_DESKTOP_WIDTH = '760px'
export const USER_PRODUCT_ONBOARDING_TOOLTIP_MOBILE_WIDTH = '315px'
export const USER_REPORT_THREAT_FORM_WIDTH = '614px'
export const USER_ENTITY_DETAIL_WIDTH = '1050px'
export const USER_SUCCESS_SCREEN_WIDTH = '720px'

export const MODAL_WIDTH = '376px'
export const MODAL_HEADER_HEIGHT = '58px'
export const DRAWER_WIDTH = '525px'
export const DRAWER_HEADER_HEIGHT = '58px'
export const VERIFICATION_RESULT_DRAWER_WIDTH = '640px'
export const HELP_CENTER_HEADER_HEIGHT = '58px'
export const HELP_CENTER_FOOTER_HEIGHT = '157px'
export const FAQ_CONTENT_WIDTH = '700px'
export const HOW_IT_WORKS_FAQ_WIDTH = '550px'
export const HOW_IT_WORKS_GET_STARTED = '670px'
export const TRADEMARK_QA_SIDEBAR_WIDTH = '310px'
export const GUIDE_SELECT_WIDTH = '640px'
export const GUIDE_SIDEBAR_WIDTH = '310px'
export const GUIDE_SELECTION_OVERVIEW_WIDTH = '900px'
export const PRICING_SIDEBAR_WIDTH = '380px'
export const PROTECTED_BY_TRAMA_CONTAINER_WIDTH = '960px'
export const PROTECTED_BY_TRAMA_SIDEBAR_WIDTH = '320px'
export const PROTECTED_BY_TRAMA_PREVIEW_MIN_HEIGHT = '200px'
export const PROTECTED_BY_TRAMA_PREVIEW_MAX_HEIGHT = '320px'
export const WORLD_MAP_DESKTOP_WIDTH = '1024px'
export const WORLD_MAP_DESKTOP_HEIGHT = '495px'
export const LEGAL_SERVICE_FORM_MAX_WIDTH = '520px'
export const LEGAL_SERVICE_FORM_MIN_WIDTH = '430px'
export const TRADEMARK_DISPUTE_SEARCH_WIDTH = '570px'
export const TRADEMARK_DISPUTE_CASE_COVER_HEIGHT_DESKTOP = '375px'
export const TRADEMARK_DISPUTE_CASE_COVER_HEIGHT_MOBILE = '200px'
export const TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_DESKTOP = '228px'
export const TRADEMARK_DISPUTE_COMPARISON_CARD_HEIGHT_MOBILE = '130px'
export const KNOWLEDGE_BASE_SIDEBAR_WIDTH = '310px'
export const BANNER_MAX_WIDTH_MOBILE = '480px'
export const CONFIRMATION_MODAL_WIDTH = '415px'
export const PROFILE_DROPDOWN_WIDTH = '320px'
export const HALL_OF_FAME_SIDEBAR_WIDTH = '280px'
export const WIPO_CALCULATOR_SIDEBAR_WIDTH = '365px'
export const DEBUG_MODAL_WIDTH = '600px'

export const USE_IN_COMMERCE_REQUEST_ABANDON_MODAL_WIDTH = '560px'
export const USE_IN_COMMERCE_REQUEST_SUBMIT_MODAL_WIDTH = '500px'

export const THREAD_COMMENT_TOOLBAR_HEIGHT = '34px'
export const THREAD_COMMENT_TOOLBAR_GAP = theme.spacing[2]
export const THREAD_COMMENT_DROPZONE_DESKTOP_HEIGHT = '55px'
export const THREAD_COMMENT_DROPZONE_MOBILE_HEIGHT = '72px'
export const THREAD_COMMENT_INPUT_MIN_HEIGHT = '90px'

export const DASHBOARD_ROW_GAP = theme.spacing[6]
export const DASHBOARD_COLUMN_GAP = theme.spacing[5]

export const MISSIVE_BUTTON_SIZE = '62px'
export const MISSIVE_BUTTON_OFFSET = '20px'
